import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/mf2.jpg";
import { jwtDecode } from "jwt-decode";


const HeaderLayout = () => {

  const [userName, setUserName] = useState(null);

  useEffect(() => {
  const token = localStorage.getItem("token");
  if(token){
    const decoded = jwtDecode(token);
    setUserName(decoded.data.login);
  }
}, []);

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  //success
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-white" style={{ borderBottom: '6px solid #198754' }}>
  <div className="container-fluid">
    <a className="navbar-brand" href="#">
      <img src={logo} style={{width:'300px'}} />
    </a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="true" aria-label="Toggle navigation">
      {/* <span className="navbar-toggler-icon"></span> */}

      <span>
      <i className='fas fa-bars' style={{color: '#198754'}}></i>
     </span>

    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav m-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <Link className="nav-link active text-dark " aria-current="page" to="/verify-tf">Vérifier TF
</Link>
        </li>

         <li className="nav-item">
          <Link className="nav-link  text-dark " to="/mes-ventes">Mes Ventes</Link>
        </li>

        <li className="nav-item">
          <Link className="nav-link text-dark " aria-current="page" to="/hypotheque-tf">Hypothéquer  TF</Link>
        </li>

        <li className="nav-item">
          <Link className="nav-link text-dark " aria-current="page" to="/mes-hypotheques">Mes hypothèques</Link>
        </li>
       
        <li className="nav-item">
          <Link className="nav-link text-dark " aria-current="page" to="/enregistrement-vente">Enregistrement des actes</Link>
        </li>        
   
      </ul>

      <div className="d-flex">
          <div class="btn-group">
            <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
              {userName ? userName : ''}
            </button>
            <ul class="dropdown-menu">
              <li><Link className="dropdown-item" to="/modifier/mot/passe">Modifier votre mot de passe</Link></li>
              <li><hr className="dropdown-divider" /></li>
              <li><Link className="dropdown-item" onClick={logout}><i className="fas fa-right-from-bracket me-2"></i> Déconnexion</Link></li>
            </ul>
          </div>

        {/* <li className="nav-item dropdown">
           <Link className="nav-link dropdown-toggle text-dark text-uppercase" id="navbarDropdownMenuLink" role="button" data-bs-toggle="dropdown" aria-expanded="false" to="/mes-ventes">{userName ? userName : ''}</Link>

            <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdownMenuLink">
                  <li><Link className="dropdown-item" >Modifier votre mot de passe</Link></li>
                        <li><hr className="dropdown-divider" /></li>
                        <li><Link className="dropdown-item" onClick={logout} ><i className="fas fa-right-from-bracket me-2"></i> Déconnexion</Link></li>
                      </ul>
        </li> */}
      </div>
      
     

    </div>
  </div>
</nav>
    
  );
};

export default HeaderLayout;






// <li classNameName="nav-item">
//               <Link to="/creer-vente" classNameName="nav-link text-white">
//                 <FaPlusCircle classNameName="me-1" />
//                 Créer une vente
//               </Link>
//             </li>